import React from 'react';

import FocusedNavView, { FocusedNavProps } from './FocusedNavView';
import { useFocusedNavDynamicProps } from './useFocusedNavDynamicProps';

/**
 * Thin data wrapper for the logged-in nav. Its only job is to fetch the async
 * `dynamicProps` payload (notifications, premium upsells, feature flags) and
 * hand it to the presentational `FocusedNavView`. Keeping the single fetch here
 * — rather than inside the view — is what lets Storybook render every nav state
 * by stubbing one object, with no fetch mocking. This is the component the
 * server mounts via `react_component('FocusedNav', ...)`.
 */
const FocusedNav = (props: FocusedNavProps) => {
  const dynamicProps = useFocusedNavDynamicProps();
  return <FocusedNavView {...props} dynamicProps={dynamicProps} />;
};

export default FocusedNav;
